import { computed, unref } from 'vue';

/** Maps default `i-woot-*` / provider icons to solid Remix icons when the channel badge is emphasized (e.g. active conversation card). */
const WOOT_ICON_TO_RI_FILLED = {
  'i-woot-api': 'i-ri-code-s-slash-fill',
  'i-woot-mail': 'i-ri-mail-fill',
  'i-woot-messenger': 'i-ri-messenger-fill',
  'i-woot-line': 'i-ri-line-fill',
  'i-woot-sms': 'i-ri-message-3-fill',
  'i-woot-telegram': 'i-ri-telegram-fill',
  'i-woot-x': 'i-ri-twitter-x-fill',
  'i-woot-website': 'i-ri-global-fill',
  'i-woot-whatsapp': 'i-ri-whatsapp-fill',
  'i-woot-instagram': 'i-ri-instagram-fill',
  'i-woot-tiktok': 'i-ri-tiktok-fill',
  'i-woot-voice': 'i-ri-phone-fill',
  'i-woot-outlook': 'i-ri-microsoft-fill',
  'i-woot-gmail': 'i-ri-google-fill',
};

export function useChannelIcon(inbox, filled = false) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-api',
    'Channel::Email': 'i-woot-mail',
    'Channel::FacebookPage': 'i-woot-messenger',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-woot-telegram',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-woot-x',
    'Channel::WebWidget': 'i-woot-website',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::WhatsappBrowser': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-woot-voice',
  };

  const providerIconMap = {
    microsoft: 'i-woot-outlook',
    google: 'i-woot-gmail',
    waha_browser_whatsapp: 'i-woot-whatsapp',
  };

  const channelIcon = computed(() => {
    const inboxDetails = unref(inbox);
    const useFilled = unref(filled);
    const type = inboxDetails.channel_type;
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inboxDetails.provider) {
      if (Object.keys(providerIconMap).includes(inboxDetails.provider)) {
        icon = providerIconMap[inboxDetails.provider];
      }
    }

    if (
      type === 'Channel::Api' &&
      inboxDetails.provider === 'waha_browser_whatsapp'
    ) {
      icon = providerIconMap.waha_browser_whatsapp;
    }

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    const resolved = icon ?? 'i-ri-global-fill';
    if (!useFilled) {
      return resolved;
    }
    return WOOT_ICON_TO_RI_FILLED[resolved] ?? resolved;
  });

  return channelIcon;
}
